import { Oval } from "react-loader-spinner";

export const LoadingOval = ({
  loaderHeight = "24",
  loaderWidth = "24",
  color = "#ffffff",
}) => {
  return (
    <Oval
      visible={true}
      height={loaderHeight}
      width={loaderWidth}
      ariaLabel="oval-loading"
      wrapperStyle={{}}
      wrapperClass=""
      color={color}
      strokeWidth={0}
      strokeWidthSecondary={5}
    />
  );
};

export const AppLoader = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <LoadingOval loaderWidth="30" loaderHeight="30" />
    </div>
  );
};
